/**
****************************************************************************************
Project: Readabl
File: PageNumberComponent.js
Description: This file will display total number of pages and current page viewed in the screen.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React from "react";
import { Input } from "@mui/material";

const PageNumberComponent = (props) => {
    return (
        props.total ? <div className="pdf-viewer-page-number-container">
            <Input 
                className="bb-page-value" 
                value={props.currentPage || 1}
                variant="outlined"
                sx={{
                    "input": {
                        width: "30px", 
                        padding: "1px",
                        textAlign: "center",
                        background: "#191b1c",
                        color: "#fff"
                    }
                }}
                />
            <div className="pdf-viewer-page-number-split">/</div>
            <div className="pdf-viewer-page-number-value">{props.total}</div>
        </div> : null
    )
}

export default PageNumberComponent;